@if (locationSummaryDtos && groupSeriesDtos) {
  <div class="page-root">
    <mat-card>
      <mat-card-header class="row-space-between">
        <mat-card-title>{{ "form.label.location" | transloco }}</mat-card-title>
      </mat-card-header>

      <mat-card-content class="column-stretch">
        <mat-form-field>
          <mat-label>{{ "form.label.location" | transloco }}</mat-label>
          <mat-select (selectionChange)="changeLocation($event)" [formControl]="locationFormControl">
            @for (locationSummaryDto of locationSummaryDtos; track $index) {
              <mat-option [value]="locationSummaryDto.locationId"> {{ locationSummaryDto.name }}
                - {{ locationSummaryDto.city }}, {{ locationSummaryDto.street }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </mat-card-content>
    </mat-card>

    <mat-card>
      <mat-card-header>
        <mat-card-title>{{"group_series.title" | transloco}}</mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <mat-table [dataSource]="groupSeriesDtos" cdkDropList (cdkDropListDropped)="reorder($event)" class="width-none"
                   #table>
          <ng-container matColumnDef="title">
            <mat-header-cell *matHeaderCellDef>{{"form.label.title" | transloco}}</mat-header-cell>
            <mat-cell *matCellDef="let groupSeries" class="row-gap-small-center">
              <mat-icon class="no-shrink">reorder</mat-icon>
              <div>{{ groupSeries.title }}</div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="duration">
            <mat-header-cell *matHeaderCellDef>{{ "form.label.duration" | transloco }}</mat-header-cell>
            <mat-cell *matCellDef="let groupSeries">{{ groupSeries.start | date: 'dd.MM.yyyy' }}
              - {{ groupSeries.end | date: 'dd.MM.yyyy' }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="employee">
            <mat-header-cell *matHeaderCellDef>{{ "form.label.employee" | transloco }}</mat-header-cell>
            <mat-cell *matCellDef="let groupSeries">{{ groupSeries.therapist }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="link">
            <mat-header-cell *matHeaderCellDef>{{ "form.label.direct_url" | transloco}}</mat-header-cell>
            <mat-cell *matCellDef="let groupSeries">
                <button mat-icon-button [matMenuTriggerFor]="locationMenu">
                  <mat-icon>link</mat-icon>
                </button>
                <mat-menu #locationMenu="matMenu">
                  @for (location of locationSummaryDtos; track $index) {
                    <button mat-menu-item (click)="copyUrl(location.locationId, groupSeries.title)">{{locationName(location.locationId)}}</button>
                  }
                </mat-menu>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="edit">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let groupSeries" class="row-end">
              <button mat-icon-button (click)="edit(groupSeries)">
                <mat-icon>edit</mat-icon>
              </button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef='["title", "duration", "employee", "link", "edit"]'></mat-header-row>
          <mat-row *matRowDef='let groupSeries; columns: ["title", "duration", "employee", "link", "edit"]' cdkDrag
                   [cdkDragData]="groupSeries"></mat-row>
        </mat-table>
      </mat-card-content>
    </mat-card>
  </div>
}
